import { Badge } from '@/ui'

const NavigationCountIconRestructured = ({ count }: { count: number }) => {
  if (!count) return null
  return (
    <Badge
      color="orange"
      size="sm"
      className="min-w-[20px] min-h-[20px] justify-center self-center rounded-full bg-orange-100 px-1.5 py-0.5 text-xs leading-none"
    >
      {count > 99 ? '99+' : count}
    </Badge>
  )
}

export default NavigationCountIconRestructured
